// Flavourite Wine — lichtgewicht verlanglijst (verlanglijst-hartje op de kaart en
// productpagina). Puur client-side via localStorage; nog geen backend/account.
// TIJDELIJK: vervangen zodra er een echte verlanglijst-/accountflow is.
const KEY = 'flav-wishlist';

function read() {
  try {
    const v = JSON.parse(localStorage.getItem(KEY) || '[]');
    return Array.isArray(v) ? v : [];
  } catch (e) {
    return [];
  }
}
function write(list) {
  try {
    localStorage.setItem(KEY, JSON.stringify(list));
  } catch (e) {
    /* opslag geweigerd; stil negeren */
  }
}

class FlavWishlistHeart extends HTMLElement {
  connectedCallback() {
    this.productId = this.getAttribute('data-product-id');
    this.button = this.querySelector('button');
    if (!this.button) return;
    this.sync();
    this.button.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      this.toggle();
    });
  }
  has() {
    return read().includes(this.productId);
  }
  sync() {
    const on = this.has();
    this.button.setAttribute('aria-pressed', on ? 'true' : 'false');
    this.button.setAttribute('aria-label', on ? 'Uit verlanglijst halen' : 'Aan verlanglijst toevoegen');
  }
  toggle() {
    let list = read();
    if (this.has()) list = list.filter((id) => id !== this.productId);
    else list.push(this.productId);
    write(list);
    this.sync();
  }
}

if (!customElements.get('flav-wishlist-heart')) {
  customElements.define('flav-wishlist-heart', FlavWishlistHeart);
}
